// Shared Quick Actions vocabulary and table-filter helpers so multiple tables
// (e.g. Variants, Patients for Review) can offer the same Quick Action(s) filter.

// Canonical labels; must match the button/badge text so filter options read the same.
export const QUICK_ACTION_LABELS = {
  newReview: 'New Review',
  assigned: 'Assigned to Me',
  readyForConsensus: 'Ready for Consensus',
  consensusInProgress: 'Consensus in Progress',
  consensusComplete: 'Consensus Complete',
};

// Field name holding the derived Quick Action labels on an augmented row.
export const QUICK_ACTIONS_FIELD = 'quickActions';

// Filter entry for TableFilterConfig; enables multiselect filtering by Quick Action.
export const quickActionsFilterConfig = {
  type: 'quickActions',
  label: 'Quick Action(s)',
  field: QUICK_ACTIONS_FIELD,
};

// Attach a synthetic quickActions field to each row using a table-specific deriver.
export const withQuickActions = (rows, getActionsForRow) =>
  rows.map((row) => ({ ...row, [QUICK_ACTIONS_FIELD]: getActionsForRow(row) }));
